const locationsFr = [
  {
    "id": 29509,
    "city": "Amman",
    "address": "",
    "code": "AMM",
    "value": "AMM",
    "destination_translations": "",
    "language": "fr",
    "country": "Jordanie"
  },
  {
    "id": 29503,
    "city": "Amsterdam",
    "address": "",
    "code": "AMS",
    "value": "AMS",
    "destination_translations": "",
    "language": "fr",
    "country": "Pays-Bas"
  },
  {
    "id": 29494,
    "city": "Ankara",
    "address": "",
    "code": "ESB",
    "value": "ESB",
    "destination_translations": "",
    "language": "fr",
    "country": "Turquie"
  },
  {
    "id": 29485,
    "city": "Antalya",
    "address": "",
    "code": "AYT",
    "value": "AYT",
    "destination_translations": "",
    "language": "fr",
    "country": "Turquie"
  },
  {
    "id": 29477,
    "city": "Athènes",
    "address": "",
    "code": "ATH",
    "value": "ATH",
    "destination_translations": "",
    "language": "fr",
    "country": "Grèce"
  },
  {
    "id": 29467,
    "city": "Barcelona",
    "address": "",
    "code": "BCN",
    "value": "BCN",
    "destination_translations": "",
    "language": "fr",
    "country": "Spania"
  },
  {
    "id": 29461,
    "city": "Bari",
    "address": "",
    "code": "BRI",
    "value": "BRI",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29454,
    "city": "Beyrouth",
    "address": "",
    "code": "BEY",
    "value": "BEY",
    "destination_translations": "",
    "language": "fr",
    "country": "Liban"
  },
  {
    "id": 29441,
    "city": "Belgrad",
    "address": "",
    "code": "BEG",
    "value": "BEG",
    "destination_translations": "",
    "language": "fr",
    "country": "Serbie"
  },
  {
    "id": 29431,
    "city": "Bilbao",
    "address": "",
    "code": "BIO",
    "value": "BIO",
    "destination_translations": "",
    "language": "fr",
    "country": "Espagne"
  },
  {
    "id": 29418,
    "city": "Bodrum",
    "address": "",
    "code": "BJV",
    "value": "BJV",
    "destination_translations": "",
    "language": "fr",
    "country": "Turcia"
  },
  {
    "id": 29412,
    "city": "Bologna",
    "address": "",
    "code": "BLQ",
    "value": "BLQ",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29401,
    "city": "Brindisi",
    "address": "",
    "code": "BDS",
    "value": "BDS",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29395,
    "city": "Bruxelles",
    "address": "",
    "code": "BRU",
    "value": "BRU",
    "destination_translations": "",
    "language": "fr",
    "country": "Belgia"
  },
  {
    "id": 29385,
    "city": "Bucuresti",
    "address": "",
    "code": "OTP",
    "value": "OTP",
    "destination_translations": "București\nBucuresti\nBucharest\nBucarest\nBukarest\nHenri Coanda\nHenri Coandă\nRoumanie\nRomânia\nRomania",
    "language": "fr",
    "country": "Roumanie"
  },
  {
    "id": 29376,
    "city": "Budapesta",
    "address": "",
    "code": "BUD",
    "value": "BUD",
    "destination_translations": "",
    "language": "fr",
    "country": "Ungaria"
  },
  {
    "id": 29358,
    "city": "Cairo",
    "address": "",
    "code": "CAI",
    "value": "CAI",
    "destination_translations": "",
    "language": "fr",
    "country": "Egipt"
  },
  {
    "id": 29353,
    "city": "Catane",
    "address": "",
    "code": "CTA",
    "value": "CTA",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  // {
  //   "id": 29343,
  //   "city": "Chisinau",
  //   "address": "",
  //   "code": "KIV",
  //   "value": "KIV",
  //   "destination_translations": "",
  //   "language": "fr",
  //   "country": "Moldavie"
  // },
  {
    "id": 29335,
    "city": "Cluj-Napoca",
    "address": "",
    "code": "CLJ",
    "value": "CLJ",
    "destination_translations": "",
    "language": "fr",
    "country": "Roumanie"
  },
  {
    "id": 29325,
    "city": "Detroit",
    "address": "",
    "code": "DTW",
    "value": "DTW",
    "destination_translations": "",
    "language": "fr",
    "country": "États-Unis"
  },
  {
    "id": 29311,
    "city": "Frankfurt",
    "address": "",
    "code": "FRA",
    "value": "FRA",
    "destination_translations": "",
    "language": "fr",
    "country": "Allemagne"
  },
  {
    "id": 29301,
    "city": "Genova",
    "address": "",
    "code": "GOA",
    "value": "GOA",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29296,
    "city": "Grande Canarie",
    "address": "",
    "code": "LPA",
    "value": "LPA",
    "destination_translations": "",
    "language": "fr",
    "country": "Espagne"
  },
  {
    "id": 29287,
    "city": "Iasi",
    "address": "",
    "code": "IAS",
    "value": "IAS",
    "destination_translations": "Iași\nIaşi\nIasi\nRoumanie\nRomânia\nRomania",
    "language": "fr",
    "country": "Roumanie"
  },
  {
    "id": 29280,
    "city": "Istanbul",
    "address": "",
    "code": "IST",
    "value": "IST",
    "destination_translations": "",
    "language": "fr",
    "country": "Turquie"
  },
  {
    "id": 29272,
    "city": "Izmir",
    "address": "",
    "code": "ADB",
    "value": "ADB",
    "destination_translations": "",
    "language": "fr",
    "country": "Turcia"
  },
  {
    "id": 29261,
    "city": "Milan",
    "address": "",
    "code": "LIN",
    "value": "LIN",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29256,
    "city": "Lisabona",
    "address": "",
    "code": "LIS",
    "value": "LIS",
    "destination_translations": "",
    "language": "fr",
    "country": "Portugalia"
  },
  {
    "id": 29251,
    "city": "Londra",
    "address": "",
    "code": "LHR",
    "value": "LHR",
    "destination_translations": "",
    "language": "fr",
    "country": "Regatul Unit"
  },
  {
    "id": 29245,
    "city": "Lyon",
    "address": "",
    "code": "LYS",
    "value": "LYS",
    "destination_translations": "",
    "language": "fr",
    "country": "Franța"
  },
  {
    "id": 29240,
    "city": "Madrid",
    "address": "",
    "code": "MAD",
    "value": "MAD",
    "destination_translations": "",
    "language": "fr",
    "country": "Spania"
  },
  {
    "id": 29236,
    "city": "Malaga",
    "address": "",
    "code": "AGP",
    "value": "AGP",
    "destination_translations": "",
    "language": "fr",
    "country": "Espagne"
  },
  {
    "id": 29230,
    "city": "Marsilia",
    "address": "",
    "code": "MRS",
    "value": "MRS",
    "destination_translations": "",
    "language": "fr",
    "country": "Franța"
  },
  {
    "id": 29225,
    "city": "Montpellier",
    "address": "",
    "code": "MPL",
    "value": "MPL",
    "destination_translations": "",
    "language": "fr",
    "country": "Franța"
  },
  {
    "id": 29210,
    "city": "Napoli",
    "address": "",
    "code": "NAP",
    "value": "NAP",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29202,
    "city": "Nice",
    "address": "",
    "code": "NCE",
    "value": "NCE",
    "destination_translations": "",
    "language": "fr",
    "country": "France"
  },
  {
    "id": 29195,
    "city": "Oradea",
    "address": "",
    "code": "OMR",
    "value": "OMR",
    "destination_translations": "",
    "language": "fr",
    "country": "Roumanie"
  },
  {
    "id": 29190,
    "city": "Palermo",
    "address": "",
    "code": "PMO",
    "value": "PMO",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29187,
    "city": "Palma de Majorque",
    "address": "",
    "code": "PMI",
    "value": "PMI",
    "destination_translations": "",
    "language": "fr",
    "country": "Espagne"
  },
  {
    "id": 29180,
    "city": "Paris",
    "address": "",
    "code": "CDG",
    "value": "CDG",
    "destination_translations": "",
    "language": "fr",
    "country": "Franța"
  },
  {
    "id": 29175,
    "city": "A Coruna",
    "address": "A Coruna Airport",
    "code": "LCG",
    "value": "LCG",
    "destination_translations": "La Coruna\nLa Coruña\nA Coruña\nA Coruña Airport\nA Coruña Airport",
    "language": "fr",
    "country": "Espagne"
  },
  {
    "id": 29172,
    "city": "Prague",
    "address": "",
    "code": "PRG",
    "value": "PRG",
    "destination_translations": "",
    "language": "fr",
    "country": "République tchèque"
  },
  {
    "id": 29165,
    "city": "Riad",
    "address": "",
    "code": "RUH",
    "value": "RUH",
    "destination_translations": "",
    "language": "fr",
    "country": "Arabie saoudite"
  },
  {
    "id": 29160,
    "city": "Riga",
    "address": "",
    "code": "RIX",
    "value": "RIX",
    "destination_translations": "",
    "language": "fr",
    "country": "Lettonie"
  },
  {
    "id": 29157,
    "city": "Rome",
    "address": "",
    "code": "FCO",
    "value": "FCO",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29150,
    "city": "Salonic",
    "address": "",
    "code": "SKG",
    "value": "SKG",
    "destination_translations": "",
    "language": "fr",
    "country": "Grèce"
  },
  {
    "id": 29142,
    "city": "Sofia",
    "address": "",
    "code": "SOF",
    "value": "SOF",
    "destination_translations": "",
    "language": "fr",
    "country": "Bulgarie"
  },
  {
    "id": 29135,
    "city": "Strasbourg",
    "address": "",
    "code": "SXB",
    "value": "SXB",
    "destination_translations": "",
    "language": "fr",
    "country": "Franța"
  },
  {
    "id": 29130,
    "city": "Suceava",
    "address": "",
    "code": "SCV",
    "value": "SCV",
    "destination_translations": "",
    "language": "fr",
    "country": "Roumanie"
  },
  {
    "id": 29127,
    "city": "Tallinn",
    "address": "",
    "code": "TLL",
    "value": "TLL",
    "destination_translations": "",
    "language": "fr",
    "country": "Estonie"
  },
  {
    "id": 29120,
    "city": "Tampere",
    "address": "",
    "code": "TMP",
    "value": "TMP",
    "destination_translations": "",
    "language": "fr",
    "country": "Finlanda"
  },
  {
    "id": 29117,
    "city": "Tel Aviv",
    "address": "",
    "code": "TLV",
    "value": "TLV",
    "destination_translations": "",
    "language": "fr",
    "country": "Israël"
  },
  {
    "id": 29110,
    "city": "Tenerife",
    "address": "",
    "code": "TFN",
    "value": "TFN",
    "destination_translations": "",
    "language": "fr",
    "country": "Spania"
  },
  {
    "id": 29105,
    "city": "Timisoara",
    "address": "",
    "code": "TSR",
    "value": "TSR",
    "destination_translations": "",
    "language": "fr",
    "country": "Roumanie"
  },
  {
    "id": 29100,
    "city": "Torino",
    "address": "",
    "code": "TRN",
    "value": "TRN",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29097,
    "city": "Toulouse",
    "address": "",
    "code": "TLS",
    "value": "TLS",
    "destination_translations": "",
    "language": "fr",
    "country": "France"
  },
  {
    "id": 29085,
    "city": "Venetia",
    "address": "",
    "code": "VCE",
    "value": "VCE",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 29082,
    "city": "Vienne",
    "address": "",
    "code": "VIE",
    "value": "VIE",
    "destination_translations": "",
    "language": "fr",
    "country": "Autriche"
  },
  {
    "id": 29075,
    "city": "Vilnius",
    "address": "",
    "code": "VNO",
    "value": "VNO",
    "destination_translations": "",
    "language": "fr",
    "country": "Lituanie"
  },
  {
    "id": 29029,
    "city": "Washington",
    "address": "",
    "code": "IAD",
    "value": "IAD",
    "destination_translations": "",
    "language": "fr",
    "country": "États-Unis"
  },
  {
    "id": 29069,
    "city": "Baia Mare",
    "address": "",
    "code": "BAY",
    "value": "BAY",
    "destination_translations": "",
    "language": "fr",
    "country": "Roumanie"
  },
  {
    "id": 7955,
    "city": "Cagliari",
    "address": "Cagliari Elmas Airport",
    "code": "CAG",
    "value": "CAG",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 45607,
    "city": "La Corogne",
    "address": "A Coruña Airport",
    "code": "LCG",
    "value": "LCG",
    "destination_translations": "La Coruna\nLa Coruña\nA Coruña\nA Coruña Airport\nA Coruña Airport",
    "language": "fr",
    "country": "Espagne"
  },
  {
    "id": 34308,
    "city": "New York",
    "address": "",
    "code": "JFK",
    "value": "JFK",
    "destination_translations": "",
    "language": "fr",
    "country": "États-Unis"
  },
  {
    "id": 32947,
    "city": "Tirana",
    "address": "Aéroport international de Tirana Nënë Tereza",
    "code": "TIA",
    "value": "TIA",
    "destination_translations": "Tirana\nTiranë\nRinas\nAlbania\nShqipëri",
    "language": "fr",
    "country": "Albanie"
  },
  {
    "id": 34328,
    "city": "Vigo",
    "address": "Vigo Airport",
    "code": "VGO",
    "value": "VGO",
    "destination_translations": "",
    "language": "fr",
    "country": "Espagne"
  },
  {
    "id": 44863,
    "city": "Dublin",
    "address": "Dublin Airport",
    "code": "DUB",
    "value": "DUB",
    "destination_translations": "",
    "language": "fr",
    "country": "Irlande"
  },
  {
    "id": 44871,
    "city": "Copenhague",
    "address": "Copenhagen Airport",
    "code": "CPH",
    "value": "CPH",
    "destination_translations": "",
    "language": "fr",
    "country": "Danemark"
  },
  {
    "id": 44878,
    "city": "Göteborg",
    "address": "Göteborg Landvetter Airport",
    "code": "GOT",
    "value": "GOT",
    "destination_translations": "",
    "language": "fr",
    "country": "Suède"
  },
  {
    "id": 44885,
    "city": "Stockholm",
    "address": "Stockholm Arlanda Airport",
    "code": "ARN",
    "value": "ARN",
    "destination_translations": "",
    "language": "fr",
    "country": "Suède"
  },
  {
    "id": 45584,
    "city": "Florence",
    "address": "Amerigo Vespucci Airport",
    "code": "FLR",
    "value": "FLR",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 45595,
    "city": "Reggio de Calabre",
    "address": "Reggio Calabria Airport",
    "code": "REG",
    "value": "REG",
    "destination_translations": "",
    "language": "fr",
    "country": "Italie"
  },
  {
    "id": 45601,
    "city": "Porto",
    "address": "Francisco Sá Carneiro Airport",
    "code": "OPO",
    "value": "OPO",
    "destination_translations": "",
    "language": "fr",
    "country": "Portugal"
  },
  {
    "id": 45606,
    "city": "Paris",
    "address": "Aéroport de Paris-Orly",
    "code": "ORY",
    "value": "ORY", 
    "destination_translations": "",
    "language": "fr",
    "country": "France"
  },
  {
    "id": 45607,
    "city": "Chișinău",
    "address": "Aéroport international de Chișinău",
    "code": "RMO",
    "value": "RMO",
    "destination_translations": "",
    "language": "fr",
    "country": "Moldavie"
  },
  {
    "id": 46001,
    "city": "Calgary",
    "address": "Aéroport international de Calgary",
    "code": "YYC",
    "value": "YYC",
    "destination_translations": "Calgary\nCalgary Airport\nCanada",
    "language": "fr",
    "country": "Canada"
  },
  {
    "id": 46002,
    "city": "Toronto",
    "address": "Aéroport international Pearson de Toronto",
    "code": "YYZ",
    "value": "YYZ",
    "destination_translations": "Toronto\nToronto Pearson\nPearson\nCanada",
    "language": "fr",
    "country": "Canada"
  },
  {
    "id": 46003,
    "city": "Vancouver",
    "address": "Aéroport international de Vancouver",
    "code": "YVR",
    "value": "YVR",
    "destination_translations": "Vancouver\nVancouver Airport\nCanada",
    "language": "fr",
    "country": "Canada"
  },
  {
    "id": 46004,
    "city": "Boston",
    "address": "Aéroport international Logan de Boston",
    "code": "BOS",
    "value": "BOS",
    "destination_translations": "Boston\nLogan\nBoston Airport\nUnited States\nUSA",
    "language": "fr",
    "country": "États-Unis"
  },
  {
    "id": 46005,
    "city": "Las Vegas",
    "address": "Aéroport international Harry-Reid",
    "code": "LAS",
    "value": "LAS",
    "destination_translations": "Las Vegas\nHarry Reid\nMcCarran\nUnited States\nUSA",
    "language": "fr",
    "country": "États-Unis"
  },
  {
    "id": 46006,
    "city": "Los Angeles",
    "address": "Aéroport international de Los Angeles",
    "code": "LAX",
    "value": "LAX",
    "destination_translations": "Los Angeles\nLAX\nUnited States\nUSA",
    "language": "fr",
    "country": "États-Unis"
  },
  {
    "id": 46007,
    "city": "Seattle",
    "address": "Aéroport international de Seattle-Tacoma",
    "code": "SEA",
    "value": "SEA",
    "destination_translations": "Seattle\nSeattle-Tacoma\nSeaTac\nUnited States\nUSA",
    "language": "fr",
    "country": "États-Unis"
  },
  {
    "id": 46008,
    "city": "San Francisco",
    "address": "Aéroport international de San Francisco",
    "code": "SFO",
    "value": "SFO",
    "destination_translations": "San Francisco\nSFO\nUnited States\nUSA",
    "language": "fr",
    "country": "États-Unis"
  },
  {
    "id": 46009,
    "city": "Anchorage",
    "address": "Aéroport international Ted-Stevens d'Anchorage",
    "code": "ANC",
    "value": "ANC",
    "destination_translations": "Anchorage\nTed Stevens\nAlaska\nUnited States\nUSA",
    "language": "fr",
    "country": "États-Unis"
  }
];

export default locationsFr;